export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const CANONICAL_HOST = process.env.NEXT_PUBLIC_CANONICAL_HOST;

function getHeaders(token) {
  const myHeaders = new Headers();
  if (token) {
    myHeaders.append("Authorization", `Token ${token}`);
  }
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Accept", "*/*");
  return myHeaders;
}

export async function post(path, data, token = null) {
  const url = `${API_URL}${path}`;
  const headers = getHeaders(token);
  const encodedData = JSON.stringify(data);
  const res = await fetch(url, { headers, method: "POST", body: encodedData });
  try {
    const data = await res.json();
    return { data, status: res.status };
  } catch {
    return { status: res.status };
  }
}

export async function get(path, token = null) {
  const url = `${API_URL}${path}`;
  const headers = getHeaders(token);
  return fetch(url, { headers }).then((res) => res.json());
}

export async function patch(path, data, token = null) {
  const url = `${API_URL}${path}`;
  const headers = getHeaders(token);
  const encodedData = JSON.stringify(data);
  return fetch(url, { headers, method: "PATCH", body: encodedData }).then((res) => {
    if (res.status === 204) {
      return { status: 204 };
    } else {
      return res.json().then((data) => ({ data, status: res.status }));
    }
  });
}

export async function getWithStatus(path, token = null, returnErrorData = true) {
  const url = `${API_URL}${path}`;
  const headers = getHeaders(token);
  let response = null;
  let data = null;

  try {
    response = await fetch(url, { headers });
  } catch (e) {
    console.error(e);
  }

  if (response.ok || returnErrorData) {
    data = await response.json();
  }

  return { status: response.status, data: data };
}

export const getQsNested = (options) =>
  Object.keys(options).length > 0
    ? "?" +
      Object.keys(options)
        .map((key) => {
          if (Array.isArray(options[key])) {
            return options[key].map((o) => `${encodeURIComponent(key)}=${encodeURIComponent(o)}`).join("&");
          } else {
            return `${encodeURIComponent(key)}=${encodeURIComponent(options[key])}`;
          }
        })
        .join("&")
    : "";
